import moment from 'moment';

export const CalendarInputs = ({
	activeCalendar,
	selectedDateRange,
	startDate,
	endDate,
	handleStartDateChange,
	handleEndDateChange,
	handleFilterRequest,
	cancelDebounce
}) => {
	if (!activeCalendar || !selectedDateRange) return null;

	const MIN_DATE = '1900-01-01';
	const MAX_DATE = moment().format('YYYY-MM-DD');

	if (selectedDateRange === "Single Date") {
		return (
			<div className={`dashboard-date-inputs ${activeCalendar ? 'active' : ''}`}>
				<label className='calendar-label'>
					Select Date
					<input
						type="date"
						value={startDate}
						onChange={handleStartDateChange}
						onBlur={() => handleFilterRequest()}
						onFocus={cancelDebounce}
						min={MIN_DATE}
						max={MAX_DATE}
						className="date-input"
					/>
				</label>
			</div>
		);
	}

	if (selectedDateRange === "Custom Range") {
		return (
			<div className={`dashboard-date-inputs ${activeCalendar ? 'active' : ''}`}>
				<label className='calendar-label'>
					Start Date
					<input
						type="date"
						value={startDate}
						onChange={handleStartDateChange}
						onBlur={() => handleFilterRequest()}
						onFocus={cancelDebounce}
						min={MIN_DATE}
						max={MAX_DATE}
						className="date-input"
					/>
				</label>
				<label className='calendar-label'>
					End Date
					<input
						type="date"
						value={endDate}
						onChange={handleEndDateChange}
						onBlur={() => handleFilterRequest()}
						onFocus={cancelDebounce}
						min={startDate || MIN_DATE}
						max={MAX_DATE}
						className="date-input"
					/>
				</label>
			</div>
		);
	}

	return null;
};